import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const BlueLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary} !important;
`;
